import type { FilterOption } from 'src/types';

export const getActiveFilterCountString = (count: FilterOption['activeCount']) => {
  if (count === null) {
    return '';
  }

  return `(${count > 999 ? '999+' : count})`;
};
